import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  noMarginBottom: {
    marginBottom: 0
  },
  suggestionsContainer: {
    position: 'absolute',
    width: 432,
    zIndex: 10
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  },
  autocompleteContainer: {
    position: 'relative',
    paddingRight: 0
  },
  optionText: {
    fontSize: 12,
    padding: theme.spacing(2, 0)
  },
  customOptionContainer: {
    padding: theme.spacing(2, 0)
  },
  customOptionPrefix: {
    fontWeight: 600,
    marginRight: theme.spacing(1),
    fontSize: 12
  },
  customOptionCTA: {
    color: theme.colorPalette.orange_75,
    ...reskinStyles(theme, { color: theme.colors.action_text }),
    fontSize: 12
  }
});

export default makeStyles(styles);
